import { useState, useRef, useEffect } from "react";
import { MdOutlineUploadFile } from "react-icons/md";
import importExcelStore from "../../../Stores/ImportExcelStore";
import Import_constants from "../../../Constants/ImportConstants";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import { toast } from "react-toastify";
import { useAlertWithButtonActionsContext } from "../../../Context/AlertMessageContext";
import AlertWithButton from "../../MessageBox/AlertWithButton";
import { useLanguageContext } from "../../../Context/LanguageContext";
import ImportAction from "../../../Actions/ImportAction";
import { FiInfo } from "react-icons/fi";
import Tooltip from "@mui/material/Tooltip";
export default function ImportComponent({ data }) {
  const { headerTitle, subHeaderTitle, key } = { ...data };
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const setAlertWithButton = useAlertWithButtonActionsContext();
  const [fileDetails, setFileDetails] = useState(null);
  const [alertHanlder, setalertHanlder] = useState();
  const [templateExcel, setTemplateExcel] = useState("");
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [validationMessage, setValidationMessage] = useState("");
  const fileInputRef = useRef(null);

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      let reader = new FileReader();
      reader.onload = () => {
        setFileDetails((prevState) => ({
          fileList: [],
          filetoStringarray: {
            filename: file.name,
            filecontent: reader.result,
            filetyp: file.type,
          },
          dropDepth: 0,
          inDropZone: false,
        }));
      };
      reader.onerror = () => {};
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    if (key && (key === "User" || key === "Equipment")) {
      setGlobalSpinner(true);
      ImportAction.getImportConfig(key);
    }
  }, []);

  useEffect(() => {
    function getImportConfigSuccess() {
      var res = importExcelStore.getImportConfigResult();
      if (res) {
        setOptions(res[key === "User" ? "werks" : "anlagegruppes"]);
      }
      setGlobalSpinner(false);
    }
    function getImportConfigFailure() {
      var res = importExcelStore.getImportConfigResult();
      toast.error(res);
      setGlobalSpinner(false);
    }
    importExcelStore.addChangeListener(
      Import_constants.GET_IMPORT_CONFIG_ON_ID_SUCCESS,
      getImportConfigSuccess,
    );
    importExcelStore.addChangeListener(
      Import_constants.GET_IMPORT_CONFIG_ON_ID_FAILURE,
      getImportConfigFailure,
    );
    return () => {
      importExcelStore.removeChangeListener(
        Import_constants.GET_IMPORT_CONFIG_ON_ID_SUCCESS,
        getImportConfigSuccess,
      );
      importExcelStore.removeChangeListener(
        Import_constants.GET_IMPORT_CONFIG_ON_ID_FAILURE,
        getImportConfigFailure,
      );
    };
  }, []);
  useEffect(() => {
    function getTemplateDataUploadSuccess() {
      var res = importExcelStore.getUploadDataResult();
      if (res.fileData === null) {
        toast.success(localization.importSucees);
        data.handleClose("success");
      } else {
        setalertHanlder({
          message: res.message,
          _func: partailImport,
        });
        setAlertWithButton(true);
        setGlobalSpinner(false);
      }
    }

    function getTemplateDataUploadFailure() {
      var res = importExcelStore.getUploadDataResult();
      toast.error(res);

      setGlobalSpinner(false);
    }

    importExcelStore.addChangeListener(
      Import_constants.UPLOAD_TEMPLATE_DATA_SUCCESS,
      getTemplateDataUploadSuccess,
    );

    importExcelStore.addChangeListener(
      Import_constants.UPLOAD_TEMPLATE_DATA_FAILURE,
      getTemplateDataUploadFailure,
    );

    return () => {
      importExcelStore.removeChangeListener(
        Import_constants.UPLOAD_TEMPLATE_DATA_SUCCESS,
        getTemplateDataUploadSuccess,
      );

      importExcelStore.removeChangeListener(
        Import_constants.UPLOAD_TEMPLATE_DATA_FAILURE,
        getTemplateDataUploadFailure,
      );
    };
  }, []);

  /* <>--------------------------------------------------------------------Get Template End----------------------------------------------------------<> */

  useEffect(() => {
    if (templateExcel !== "") {
      const fileData = templateExcel.fileData;
      const contentType = templateExcel.fileType;
      const fileName = templateExcel.fileName;
      const blob = new Blob([base64ToArrayBuffer(fileData)], {
        type: contentType,
      });
      const url = window.URL.createObjectURL(blob);
      let a = document.createElement("a");

      a.hidden = "";
      a.href = url;
      a.download = fileName;
      a.click();
      setGlobalSpinner(false);
    }

    return () => {};
  }, [templateExcel]);

  useEffect(() => {
    function getTemplateSuccess() {
      var res = importExcelStore.getTemplateResult();
      setTemplateExcel(res);
    }
    function getTemplateFailure() {
      var res = importExcelStore.getTemplateResult();
      toast.error(res);
      setGlobalSpinner(false);
    }
    importExcelStore.addChangeListener(
      Import_constants.GET_IMPORT_TEMPLATE_SUCCESS,
      getTemplateSuccess,
    );
    importExcelStore.addChangeListener(
      Import_constants.GET_IMPORT_TEMPLATE_FAILURE,
      getTemplateFailure,
    );

    return () => {
      importExcelStore.removeChangeListener(
        Import_constants.GET_IMPORT_TEMPLATE_SUCCESS,
        getTemplateSuccess,
      );
      importExcelStore.removeChangeListener(
        Import_constants.GET_IMPORT_TEMPLATE_FAILURE,
        getTemplateFailure,
      );
    };
  }, []);

  /* <>--------------------------------------------------------------------Get Template End----------------------------------------------------------<> */

  function partailImport() {
    setAlertWithButton(false);
    setTemplateExcel(importExcelStore.getUploadDataResult());
  }

  const handleDropDownChange = (event) => {
    event.preventDefault();
    setSelectedOption(event.target.value);
    setValidationMessage(
      event.target.value === "" ? localization.alertSelectOpt : "",
    );
  };
  const handleImport = (_operationType) => {
    if (key && !selectedOption) {
      setValidationMessage(localization.alertSelectOpt);
      return;
    } else {
      if (_operationType === "import") {
        data.handleImport(fileDetails.filetoStringarray, selectedOption);
      } else {
        data.handleDownloadTemplate(selectedOption);
      }
    }
  };
  const instructions = (
    <ul style={{ paddingLeft: 16 }}>
      <li>{localization.msgRow1}</li>
      <li>{localization.msgRow2}</li>
      <li>{localization.msgRow3}</li>
      <li>{localization.msgRow4}</li>
      <li>{localization.msgRow5}</li>
      <li>{localization.msgRow6}</li>
    </ul>
  );
  return (
    <>
      <div
        className="modal in dialogBox"
        id="MsgModalCenter"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="MsgModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content importCompHeader">
            <div className="modal-header importCompHeaderInner">
              <div className="row d-flex w-100 ml-0 mr-0">
                <div className="col-10 pl-0 ">
                  <div className="importCompTitleStyle">{headerTitle}</div>
                </div>
                <div className="col p-0 d-flex justify-content-end">
                  <Tooltip title={instructions} placement="top">
                    <div style={{ cursor: "pointer" }}>
                      <FiInfo size={24} />
                    </div>
                  </Tooltip>
                </div>
              </div>

              <div>
                <div className="importCompSuBHeader">{subHeaderTitle}</div>
              </div>
            </div>
            <div className="modal-body importCompBody">
              <div className="importCompBodyInner">
                {key && (
                  <div className="importCompBodySelectDiv">
                    <div>
                      {key === "User"
                        ? localization.selectPlant
                        : localization.selectEquipmentGrp}
                    </div>

                    <select
                      className="importCompBodyDropDown"
                      value={selectedOption}
                      onChange={handleDropDownChange}
                    >
                      <option value="">{localization.seleOpt}</option>
                      {options.map((option, index) => (
                        <option key={index} value={option.id}>
                          {option.bezeichnung}
                        </option>
                      ))}
                    </select>
                    {validationMessage && (
                      <div style={{ color: "red", fontSize: 12 }}>
                        {validationMessage}
                      </div>
                    )}
                  </div>
                )}
                <div
                  className="importCompDownload"
                  onClick={() => handleImport("download")}
                >
                  {localization.downloadTemp}
                </div>
                <div>
                  <div className="importCompImportlabel">
                    {localization.selImport}
                  </div>

                  <div
                    className="importCompImportButtonOuter"
                    onClick={handleClick}
                  >
                    <div className="importCompImportButtonInner">
                      {fileDetails
                        ? fileDetails.filetoStringarray.filename
                        : localization.openFileBrowserPlaceholder}
                    </div>
                    <div>
                      <MdOutlineUploadFile size={24} color="#636B74" />
                    </div>
                  </div>
                  <input
                    className="pl-5"
                    type="file"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    accept=".xlsx, .xls"
                    onChange={handleFileChange}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer py-3 importCompFooter">
              <button
                className="importCompFooterButtonExit"
                onClick={data.handleClose}
              >
                {localization.exit}
              </button>
              <button
                className="importCompFooterButtonSave"
                disabled={!fileDetails}
                onClick={() => handleImport("import")}
              >
                {headerTitle}
              </button>
            </div>
          </div>
        </div>
      </div>
      <AlertWithButton handler={alertHanlder} />
    </>
  );
}
function base64ToArrayBuffer(base64) {
  const binaryString = window.atob(base64);
  const byteArray = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    byteArray[i] = binaryString.charCodeAt(i);
  }
  return byteArray;
}
